
import Component from "vue-class-component"
import { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import ArtikelRow from "../custom/ArtikelRow.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import ReservierungVorbestellungLogic from "@/logic/bestellung/reservierung_vorbestellung_logic"
import ReservierungVorbestellung from "./ReservierungVorbestellung.vue"
import WarenkorbArtikel from "../bestellung-neu/sub/WarenkorbArtikel.vue"
import BstlArtikel from "@/entities/common/bstl_artikel"
import ErrorBox from "../custom/ErrorBox.vue"

@Component({
  components: { ArtikelRow, FilialeHeader, WarenkorbArtikel, ErrorBox },
})
export default class ReservierungVorbestellungBestaetigen extends mixins(
  Calculator
) {
  logic: ReservierungVorbestellungLogic = null

  mounted() {
    this.logic = (this.$parent as ReservierungVorbestellung).logic
  }

  backToOverview() {
    this.logic.backToOverview()
  }

  bestellungBestaetigen() {
    this.logic.bestellungBestaetigen()
  }

  increment(artikel: BstlArtikel) {
    this.logic.increment(artikel)
  }

  decrement(artikel: BstlArtikel) {
    this.logic.decrement(artikel)
  }

  remove(artikel: BstlArtikel) {
    this.logic.remove(artikel)
  }
}
